<div class="row h-100">
  <div class="col-sm-2 settingitem">
    <setting-resource (onResouceClicked)="setResouce($event)"></setting-resource>
  </div>
  <div class="col-sm-10" *ngIf="formGroup">
    <form [formGroup]="formGroup">
      <div class="row" [ngClass]="{ settingdetail: isShowBg }">
        <ng-container *ngFor="let r of getRuleElements(systemName)">
          <ng-template [ngIf]="IsBreak(r.ControlType)" [ngIfElse]="form">
            <div class="col-sm-12"><hr /></div>
          </ng-template>
          <ng-template #form>
            <div class="items-resours-select col-sm-3 px-2">
              <!--Radio, Check-->
              <div>
                <div *ngIf="IsRadio(r.ControlType) || IsCheckBox(r.ControlType)">
                  <ssg-checkbox
                    id="chb{{ r.KeyValue }}"
                    name="{{ r.KeyValue }}"
                    [defaultHeight]="30"
                    [group]="formGroup"
                    label="{{ r.Title }}"
                    [disabled]="r.disabled"
                    required="false"
                    (valueChange)="checkboxChangeValue(r.SystemName, r.KeyValue, $event)">
                  </ssg-checkbox>
                </div>
              </div>
              <!--textnox numerictextbox-->
              <div class="body-item" *ngIf="IsTextBox(r.ControlType) == true || IsNumericTextBox(r.ControlType) || IsTimeTextBox(r.ControlType)">
                <ssg-input
                  id="txt{{ r.KeyValue }}"
                  name="{{ r.KeyValue }}"
                  [defaultHeight]="30"
                  label="{{ r.Title }}"
                  [group]="formGroup"
                  [disabled]="r.disabled"
                  required="false"
                  textType="{{ getTextBoxType(r.ControlType) }}"
                  (valueChange)="setValue(r.SystemName, r.KeyValue, $event)">
                </ssg-input>
              </div>
              <!--DropDown-->
              <div class="body-item" *ngIf="IsDropDown(r.ControlType) == true">
                <ssg-select
                  id="select{{ r.KeyValue }}"
                  name="{{ r.KeyValue }}"
                  [group]="formGroup"
                  [defaultHeight]="30"
                  label="{{ r.Title }}"
                  apiName="{{ r.apiName }}"
                  [disabled]="r.disabled"
                  textFieldName="{{ r.displayMember }}"
                  valueFieldName="{{ r.valueMember }}"
                  required="false"
                  (valueChange)="setValue(r.SystemName, r.KeyValue, $event.Code)">
                </ssg-select>
              </div>
              <div class="body-item" *ngIf="IsLookup(r.ControlType) == true">
                <st-lookup
                  id="select{{ r.KeyValue }}"
                  name="{{ r.KeyValue }}"
                  [defaultHeight]="30"
                  [group]="formGroup"
                  label="{{ r.Title }}"
                  apiName="{{ r.apiName }}"
                  [disabled]="r.disabled"
                  textFieldName="{{ r.displayMember }}"
                  valueFieldName="{{ r.valueMember }}"
                  textColumnsName="{{ r.columnsName }}"
                  required="false"
                  (valueChange)="setValue(r.SystemName, r.KeyValue, $event)">
                </st-lookup>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </form>
  </div>
</div>
